module.exports = __webpack_public_path__ + "static/media/Gen Doc - GBR Network - 21-03-2025 N.6bf5a69d.png";